import { ElementProps } from "../../../types/common";

export const ArrowIconMobile = (props: ElementProps) => (
  <svg
    width={14}
    height={14}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m2.841 10.095 5.801-5.801H4.445l.01-1.099h6.157v6.158H9.504l.01-4.188-5.802 5.801-.87-.871Z"
      fill="#4132EB"
    />
  </svg>
);
